import { useState, useEffect } from "react";
import HeaderHome from "../headers/headerHome";
import * as API from "../services/API";
import "../css/QsnAdmin.css";
import Footer from "../components/Footer";
// Composant affichage public
function PublicQsn({ blocks }) {
  const safeBlocks = Array.isArray(blocks) ? blocks : [];

  if (safeBlocks.length === 0)
    return (
      <div className="text-center text-muted py-5">
        Aucun contenu disponible
      </div>
    );

  return (
    <div className="container py-5">
      {safeBlocks.map((block) => (
        <div
  key={block.id}
  className="mb-5 p-4 rounded-4 shadow-sm"
  style={{ backgroundColor: "#FFFFFF" }}
>
  {/* TITRE */}
  <div
    className="mb-3 px-4 py-2 text-dark"
    style={{
      fontWeight: 700,
      borderRadius: "0.5rem",
      fontSize: "2rem",
      display: "inline-block",
    }}
  >
    {block.title || "Titre du bloc"}
  </div>

  {/* IMAGE + TEXTE */}
  <div
    className={`d-flex align-items-start mt-2 py-3 flex-column flex-md-row ${
      block.position === "right" ? "flex-md-row-reverse" : ""
    }`}
  >
    {block.image ? (
      <img
        src={block.image}
        alt=""
        className="rounded-4 shadow-sm"
        style={{ width: 300, height: "auto", objectFit: "cover" }}
      />
    ) : (<></>
      // <div
      //   style={{
      //     width: 240,
      //     height: 240,
      //     backgroundColor: "#E5E7EB",
      //     display: "flex",
      //     justifyContent: "center",
      //     alignItems: "center",
      //     borderRadius: "1rem",
      //     color: "#6B7280",
      //     fontWeight: 600,
      //     boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      //   }}
      // >
      //   Image
      // </div>
    )}

    <div className="mt-3 mt-md-0 px-md-4" style={{ flex: 1 }}>
      <p
        className="mb-0"
        style={{ color: "#4B5563", lineHeight: 1.6, fontSize: "1.4rem" }}
      >
        {block.text || "Lorem ipsum dolor sit amet, consectetur adipiscing elit."}
      </p>
    </div>
  </div>
</div>
      ))}
    </div>
  );
}


// Composant principal
function QsnAdmin() {
  const [savedBlocks, setSavedBlocks] = useState([]);

  // Charger les blocs depuis le backend
  useEffect(() => {

    API.getAllQsnRequest(
      (qsn) => {
        setSavedBlocks(qsn.data);
      },
      () => {}
    );
  }, []);




  return (
    <>
    <div className="min-vh-100" style={{ backgroundColor: "#F4F6F8" }}>
      <HeaderHome/>

      <h1 className="text-center my-4 text-dark">
          Qui sommes-nous?
        </h1>

      {/* Affichage public */}
    <PublicQsn blocks={savedBlocks} />

    </div>
    <Footer/>
    </>
  );
}

export default QsnAdmin;
